namespace SorAraBul {
    export enum UserCreditTransactionType {
        yukleme = 0,
        harcama = 1,
        iade = 2
    }
    Serenity.Decorators.registerEnumType(UserCreditTransactionType, 'SorAraBul.UserCreditTransactionType');
}
